(function () {
	const hero = () => {
		$(".hero-section").each(function () {
			const cursorProgress = (slideshowSwiper) => {
				const heroImages = $(this).find(".hero_img");
				const count = heroImages.length;

				heroImages.each((index, element) => {
					$(element).css({
						"will-change": "opacity, transform",
						filter: "none",
						transform: "translate3d(0px, 0%, 0px) scale3d(1, 1, 1)",
						opacity: index === 0 ? "1" : "0",
						transition: "opacity 0.1s ease, transform 0.1s ease",
					});
				});

				let currentIndex = 0;

				if (count < 2) return;

				slideshowSwiper.addEventListener("mousemove", (e) => {
					const rect = slideshowSwiper.getBoundingClientRect();
					const swiperWidth = slideshowSwiper.clientWidth;
					const cursorX = Math.max(0, Math.min(swiperWidth, e.clientX - rect.left));

					// Map cursor across full width to float index [0, count-1]
					const imageFloat = (cursorX / swiperWidth) * (count - 1);
					const fromIndex = Math.min(Math.floor(imageFloat), count - 2);
					const progress = imageFloat - fromIndex; // 0 to 1
					const toIndex = fromIndex + 1;

					currentIndex = progress >= 0.5 ? toIndex : fromIndex;

					heroImages.each((index, element) => {
						let opacity;
						if (index === fromIndex) {
							opacity = 1 - progress;
						} else if (index === toIndex) {
							opacity = progress;
						} else {
							opacity = 0;
						}

						$(element).css({
							opacity: opacity,
							transform: `scale3d(${1 + 0.1 * opacity}, ${1 + 0.1 * opacity}, 1)`,
						});
					});
				});

				slideshowSwiper.addEventListener("mouseleave", () => {
					heroImages.each((index, element) => {
						if (index === currentIndex) {
							$(element).css({
								opacity: "1",
								transform: "scale3d(1, 1, 1)",
							});
						} else {
							$(element).css({
								opacity: "0",
								transform: "translate3d(0px, 0%, 0px) scale3d(1, 1, 1)",
							});
						}
					});
				});
			};

			cursorProgress(this.querySelector(".hero"));
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		hero();

		document.addEventListener("shopify:section:load", function () {
			hero();
		});
	});
})();
